import { Problems } from 'src/app/models/Problems'

class DataCsv {
	public requester: string
	public email_requester: string
	public cpf_requester: string
	public tel_requester: string
	public process: string
	public address: {
		lat?: string,
		lng?: string,
		street?: string
	}
	public company_id: string
	public problems: Array<Problems> = []
	public reference?: string
	public mediaUrl: Array<string> = []
}

class objectWithPositionFieldReport {
	public nome?: string
	public cpf?: string
	public processo?: string
	public latitude?: string
	public longitude?: string
	public email?: string
	public fone?: string
	public foto1?: string
	public foto2?: string
	public companhia?: string
	public problema?: string
	public endereço?: string | number
	public referencia?: string
}

class Company {
	public _id: string
	public address: string
	public social_name: string
}

export {DataCsv, objectWithPositionFieldReport, Company}
